const isProd = import.meta.env.MODE === 'production';

// Debug switch: enable by adding ?debug=1 to the URL or setting localStorage.debug = '1'
const hasDebugFlag = (() => {
  try {
    const qs = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : undefined;
    const fromQuery = qs?.get('debug') === '1';
    const fromStorage = typeof localStorage !== 'undefined' && localStorage.getItem('debug') === '1';
    return Boolean(fromQuery || fromStorage);
  } catch {
    return false;
  }
})();

const shouldLog = !isProd || hasDebugFlag; // dev: always log; prod: default off unless debug flag

// Alias global console to avoid esbuild's drop: ['console'] removing wrapper calls in production
const c = (typeof window !== 'undefined' && window.console) ? window.console : console;

export const logger = {
  debug: (...args: any[]) => { if (shouldLog) c.debug?.(...args); },
  info:  (...args: any[]) => { if (shouldLog) c.info?.(...args); },
  warn:  (...args: any[]) => { if (shouldLog) c.warn?.(...args); },
  error: (...args: any[]) => { if (shouldLog) c.error?.(...args); },
};

export default logger;